import axios from 'axios';

const deleteLockbox = async (lockboxId: string) =>
  axios.post(`/lockbox/delete/${lockboxId}`);

export default deleteLockbox;
